export const analyzVariable = function (content) {
  //解析变量
  if (content.indexOf('${reviewFlowView}') > -1) {
    let text = window.vm.$i18n.t('查看');
    content = content.replace('${policyDetail}', text);
  }
  if (content.indexOf('${policyDetail}') > -1) {
    let text = window.vm.$i18n.t('查看');
    content = content.replace('${policyDetail}', text);
  }
  if (content.indexOf('${taskList}') > -1) {
    let text = window.vm.$i18n.t('查看');
    content = content.replace('${taskList}', text);
  }
  if (content.indexOf('${reviewFlowOperate}') > -1) {
    let text = window.vm.$i18n.t('操作');
    content = content.replace('${reviewFlowOperate}', text);
  }
  return content;
};